import {
    type ExperimentsFlags as AbExperimentsFlags,
    getExperimentFlag,
    getSafeExperimentsContext,
} from '@adv-frontend/yastore-modules/lib';
import { type ExperimentFlags, experimentFlags, type FlagName, type FlagValue } from './constants';
import { getLocalExperimentalFlag } from './getLocalExperimentalFlag';

const isAbFlagName = (name: FlagName): name is keyof AbExperimentsFlags =>
    name in getSafeExperimentsContext().experimentsFlags;

const isExperimentFlagName = (name: FlagName): name is keyof ExperimentFlags => name in experimentFlags;

export const isExperimentFlagEnabled = (name: FlagName, value: FlagValue = 'exp'): boolean => {
    if (isAbFlagName(name) && getExperimentFlag(name, value)) {
        return true;
    }

    if (isExperimentFlagName(name)) {
        return getLocalExperimentalFlag({ name, value });
    }

    return false;
};

export const useExperimentFlag = isExperimentFlagEnabled;
